import { render, staticRenderFns } from "./ruleExplain.vue?vue&type=template&id=6b50ad9d"
import script from "./ruleExplain.vue?vue&type=script&lang=js"
export * from "./ruleExplain.vue?vue&type=script&lang=js"
import style0 from "./ruleExplain.vue?vue&type=style&index=0&id=6b50ad9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports